<template>
  <div>
    <ui-card
      :is-loading="isLoading"
      class="overview-card h-100"
    >
      <div class="card-header overview-card__header mb-4 pb-2">
        <ui-icon name="incomplete-accountant-registrations" size="32px" />
        <h4 class="card-title overview-card__title">
          Incomplete accountant registrations
        </h4>
      </div>
      <template v-if="previewRegistrations.length">
        <div
          v-for="item in previewRegistrations"
          :key="item.id"
          class="d-flex justify-content-between mt-3"
        >
          <router-link
            :to="{ name: 'location-view', params: { locationId: item.id }}"
            class="card-label overview-card__label"
          >
            {{ item.name }}
          </router-link>
        </div>
      </template>
      <span v-else class="text-gray">
        {{ $t('noData') }}
      </span>

      <template #footer>
        <stats-accountant-registrations-modal
          v-if="statsRegistrations.length > previewCount"
          :registrations="statsRegistrations"
        >
          <template #activator="{ open }">
            <ui-button
              link
              type="primary"
              @click="open"
            >
              {{ $t('form.buttons.viewAll') }}
            </ui-button>
          </template>
        </stats-accountant-registrations-modal>
      </template>
    </ui-card>
  </div>
</template>

<script>
import api from '@/api';
import StatsMixin from './StatsMixin';
import StatsAccountantRegistrationsModal from './StatsAccountantRegistrationsModal.vue';

export default {

  mixins: [
    StatsMixin,
  ],

  components: {
    StatsAccountantRegistrationsModal,
  },

  data: () => ({
    items: [],
    previewCount: 5,
  }),

  computed: {
    statsRegistrations() {
      return this.items.map(({ workplace }) => workplace);
    },
    previewRegistrations() {
      return this.statsRegistrations.slice(0, this.previewCount);
    },
  },

  methods: {
    async load() {
      const { data } = await api.locations.getAccountantRegistrations({
        salesId: this.staffId,
      });

      if (data) {
        this.items = data;
      }
    },
  },
};
</script>
